export const userEndpoints={
  "sendOTP":"api/send-otp",
  "verifyOTP":"api/verify-otp",
  "register":"api/register"
}
